import { call, put, takeLatest } from "redux-saga/effects";
import { doAccountSetup } from "../../../com/accountSetup";
import {
  accountSetupSuccess,
  accountSetupFailure,
  AccountSetupPayload,
} from "../../action/accountSetup";
import { ACCOUNT_SETUP_REQUEST } from "../../actionTypes/accountSetup";
import { API_CODES } from "../../../constants";

interface AccountSetupRequestAction {
  type: string;
  payload: AccountSetupPayload;
}

export function* handleAccountSetup(
  action: AccountSetupRequestAction
): Generator<unknown, void, any> {
  try {
    const response = yield call(doAccountSetup, action.payload);

    if (
      response.status === API_CODES.SUCCESS_CODE ||
      response.status === "SUCCESS"
    ) {
      yield put(accountSetupSuccess());
    } else {
      const errorMessage =
        response.statusinfo?.message || "Account setup failed. Please try again.";
      yield put(accountSetupFailure(errorMessage));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Please try again later";
    yield put(accountSetupFailure(errorMessage));
  }
}

export function* accountSetupSaga() {
  yield takeLatest(ACCOUNT_SETUP_REQUEST, handleAccountSetup);
}

